import { ICategoryChartData, IMetadataChart, IPieChartData, IStackedChartData, ChartType as MetadataChartType } from "@tylertech/tyler-api-types";

export function isPie(x: IMetadataChart): x is IPieChartData
{
    return !!x && x.Type === MetadataChartType.Pie;
}

export function isBar(x: IMetadataChart): x is ICategoryChartData
{
    return !!x && x.Type === MetadataChartType.Bar;
}

export function isColumn(x: IMetadataChart): x is ICategoryChartData
{
    return !!x && x.Type === MetadataChartType.Column;
}

export function isLine(x: IMetadataChart): x is ICategoryChartData
{
    return !!x && x.Type === MetadataChartType.Line;
}

export function isStacked(x: IMetadataChart): x is IStackedChartData
{
    return !!x
        && "Stacked" in x
        && x.Stacked as boolean;
}

export const ChartHelpers = {
    isPie,
    isBar,
    isColumn,
    isLine,
    isStacked,
};
